
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import HoursAndLocation from './components/HoursAndLocation';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#fcfaf7]">
      <Header />
      <main className="flex-grow">
        <Hero />
        <About />
        <Services />
        <HoursAndLocation />
      </main>
      <Footer />
    </div>
  );
};

export default App;
